<template>
  <div id="app">
    <Header></Header>

    <Page>
      <div class="pb-8 px-content">
        <div class="flex justify-center">
          <h1 class="headline">Projekte</h1>
        </div>

        <nav class="flex flex-wrap justify-center mt-8 mb-3">
          <a
            class="px-3 py-1 mx-2 text-gray-800 text-brand-blue"
            :class="{ 'border-brand-yellow border-b-2' : category.tag == selectedCategory.tag}"
            v-bind:key="category.tag"
            v-for="category in categories"
            v-bind:href="'?category='+category.tag"
          >{{category.title}}</a>
        </nav>

        <div class="flex flex-wrap">
          <div
            v-bind:key="projekt.imageUrl"
            v-for="projekt in filteredProjects"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1"
          >
            <div class="px-2 py-2 bg-white">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  :src="projekt.imageUrl"
                  :alt="projekt.text"
                />
              </div>
            </div>
            <h1 class="text-center mt-1 cursor-pointer">{{ projekt.text }}</h1>
          </div>
        </div>
      </div>

      <CallToAction></CallToAction>
    </Page>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CallToAction from "../components/CallToAction.vue";
import Page from "../components/Page.vue";
import Picture from "../components/Picture.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    Picture,
  },
  data() {
    return {
      categories: [
        { title: "Alle", tag: "alle" },
        { title: "Balkon", tag: "balkon" },
        { title: "Edelstahlarbeiten", tag: "edelstahlarbeiten" },
        { title: "Schmiedearbeiten", tag: "schmiedearbeiten" },
        { title: "Treppen & Geländer", tag: "treppen" },
        { title: "Überdachungen", tag: "ueberdachungen" },
        { title: "Zäune & Tore", tag: "zaeune_und_tore" },
        { title: "Gartenbereich", tag: "garten" }
      ],
      selectedCategory: undefined,
      projekte: [
        { imageUrl: "img/projekte/balkon/Balkon06.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/Balkon01.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/Balkon02.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/Balkon08.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/Balkon09.jpg", category: "balkon" },
        {
          imageUrl: "img/projekte/balkon/Balkonmittreppe.jpg",
          category: "balkon"
        },
        { imageUrl: "img/projekte/balkon/balkon.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon03.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon04.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon07.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon10.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon11.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon12.jpg", category: "balkon" },
        { imageUrl: "img/projekte/balkon/balkon_2.jpg", category: "balkon" },
        {
          imageUrl: "img/projekte/balkon/balkonbruestung.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkonbruestung_2.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkongelaender.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkongelaender03.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkongelaender_2.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkongelaender_rot.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkonglasdach_1.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkonglasdach_2.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkonverkleidung.jpg",
          category: "balkon"
        },
        {
          imageUrl: "img/projekte/balkon/balkonverkleidung02.jpg",
          category: "balkon"
        },
        { imageUrl: "img/projekte/balkon/haus.jpg", category: "balkon" },
        {
          imageUrl:
            "img/projekte/edelstahlarbeiten/Edelstahlbalkonbruestung.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl: "img/projekte/edelstahlarbeiten/Edelstahlgelaender.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl: "img/projekte/edelstahlarbeiten/Edelstahlhandlauf.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl:
            "img/projekte/edelstahlarbeiten/Edelstahlhandlauf_rathaus.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl: "img/projekte/edelstahlarbeiten/edelstahlarbeiten_250.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl: "img/projekte/edelstahlarbeiten/edelstahlpflanzgefaess.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl: "img/projekte/edelstahlarbeiten/edelstahltopf.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl:
            "img/projekte/edelstahlarbeiten/edelstahltreppengelaender.jpg",
          category: "edelstahlarbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/fenstergitter.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/geschmiedetesgelaender.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/geschmiedetestor.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl:
            "img/projekte/schmiedearbeiten/geschmiedetestreppengelaender.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/schmiedeeisen.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/schmiedeeisengitter.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/schmiedegitter.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/schmiedearbeiten/schmiedekunst.jpg",
          category: "schmiedearbeiten"
        },
        {
          imageUrl: "img/projekte/treppen/stahlgelaender.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/stahltreppe.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppenabgang.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppenabgang2.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppenaufgang.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppenaufgang_2.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppengelaender.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppengelaender22.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppenhandlauf.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/treppen/treppenhaus.jpg",
          category: "treppen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/carport.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/dach.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/dach_2.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/dach_22.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/eingangsportal.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/glasdach.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/tiefgaragendach.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/treppegelaender_tuer.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/tuerueberdachung_1.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/tuerueberdachung_2.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/ueberdachung.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/ueberdachung_1.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/ueberdachung_2.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/ueberdachungen/wintergarten.jpg",
          category: "ueberdachungen"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/Sicherheitstor.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/gartentor.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/gartentor_1.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/gartentor_2.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/gartenzaun.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/industriezaun.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/lochgestaltung.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/tor-mit-zaun.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/tor_1.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/tor_3.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/zaeune.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/zaeune_und_tore/zaun.jpg",
          category: "zaeune_und_tore"
        },
        {
          imageUrl: "img/projekte/gartenbereich/Konstruktion_Holzdeck.jpg",
          category: "garten"
        },
        {
          imageUrl: "img/projekte/gartenbereich/Terrassenunterkonstruktion.jpg",
          category: "garten"
        },
        {
          imageUrl: "img/projekte/gartenbereich/holzdeck01.jpg",
          category: "garten"
        },
        {
          imageUrl: "img/projekte/gartenbereich/holzdeck02.jpg",
          category: "garten"
        },
        {
          imageUrl: "img/projekte/gartenbereich/holzdeck03.jpg",
          category: "garten"
        },
        {
          imageUrl: "img/projekte/gartenbereich/trennwand.jpg",
          category: "garten"
        }
      ]
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const catParam = urlParams.get("category");

    if (catParam != undefined) {
      this.selectedCategory = this.categories.find((cat) => cat.tag == catParam.toLowerCase());
    }
    if (this.selectedCategory == undefined) {
      this.selectedCategory = this.categories[0];
    }
    window.console.log("created " + this.selectedCategory.tag);
  },
  computed: {
    filteredProjects() {
      return this.projekte.filter(projekt => {
        if (this.selectedCategory.tag == this.categories[0].tag) {
          return true;
        } else {
          return projekt.category == this.selectedCategory.tag;
        }
      });
    }
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/" + pic);
    }
  }
};
</script>

<style src="../assets/css/comfortaa.css"></style>
<style src="../assets/css/styles.css"></style>